import { render } from "./config_io_departments.vue?vue&type=template&id=35a43a54&scoped=true"
import script from "./config_io_departments.vue?vue&type=script&lang=js"
export * from "./config_io_departments.vue?vue&type=script&lang=js"

import "./config_io_departments.vue?vue&type=style&index=0&id=35a43a54&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a43a54"]])

export default __exports__